import { Injectable } from '@angular/core';
import {BehaviorSubject, catchError, finalize, Observable, of, tap, throwError} from "rxjs";
import {DataCoreService, DlistDto, environment as env, GetDlist_Request, GetDlist_Response} from "@dabnet-kamu/libs/ui";
import {HttpClient} from "@angular/common/http";

// ServiceStack yanıtları camelCase (bkz. GetDlist_Response.dListMetadata)
export interface LogAuditDetay {
  eskiDegerler?: string;
  yeniDegerler?: string;
  kaynak?: string;
}

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  private _gridControlsHistoryList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsHistoryList$ = this._gridControlsHistoryList.asObservable();
  constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) { }

  getHistoryDlist(formName: string) {
    // gridControlsHistoryList$ kok (root) singleton - popup her acildiginda tekrar cekmek,
    // mevcut degerin ustune yenisini basip "once eski sonra yeni deger" seklinde cifte
    // render'a yol aciyordu. Deger zaten yuklendiyse tekrar istek atmiyoruz.
    if (this._gridControlsHistoryList.value) {
      return;
    }
    const request=new GetDlist_Request({
      dListCode:formName
    })
    this._httpClient.post<GetDlist_Response>(`${env.ortakService}/System/GetDList`, request).pipe(
      tap(response => {
        if(formName === 'vLogAudit'){
          this._gridControlsHistoryList.next(response.dListMetadata)
        }


      }),
      catchError(err => throwError(err)),
      finalize(() => {})
    ).subscribe();
  }

  // LOG_AUDIT detayı (12.10.2026): 4000'i aşan JSON'un LOG_AUDIT_EK'teki tam hali (KOD = LOG_AUDIT.KOD) + satır kaynağı (KAYNAK).
  // Tablo/kolon DB'de yoksa servis boş döner; hata durumunda da boş nesneyle devam edilir (ekran düşmez).
  getLogAuditDetay(request: {kod: number}): Observable<LogAuditDetay> {
    return this._httpClient.post<LogAuditDetay>(`${env.ortakService}/GEN/LogAudit/LogAuditDetayGetir`, request).pipe(
      catchError(() => of({} as LogAuditDetay))
    );
  }

  getHistoryData(entityName:string, selectedRowData:{Donem:number, Kod:any}) {
    const dataSource = this.dataCoreService.getOData('vLogAudit');
    //dataSource.select(['TebKurumSinif.Ad'])
    if(entityName){
      const filterArr = [];
      filterArr.push(['TabloAd', '=', entityName], ['PkDeger', '=', selectedRowData.Kod.toString()]);
      dataSource.filter(filterArr);
    }

    dataSource.pageSize(100);
    return dataSource;
  }
}
